$(document).ready(function() {
    autoAjax.setOptions({
        showInputErrors: false,
        messages: {
            error: __('Ospravedlňujeme sa, no nastala nečakaná chyba, skúste neskôr prosím.'),
            validation: __('Nevyplnili ste všetky potrebné polia.'),
        },
    });

    $('.autoAjax').autoAjax();

    // tooltip
    $(function() {
        $('[data-toggle="tooltip"]').tooltip()
    });

    // vh hack js+css
    let vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', `${vh}px`);
    window.addEventListener('resize', () => {
        let vh = window.innerHeight * 0.01;
        document.documentElement.style.setProperty('--vh', `${vh}px`);
    });

    // fixed header
    var header = $('.js-header-wrapper'),
        headerH = header.height();

    $(window).on('scroll', function() {
        if ($(this).scrollTop() + 10 >= headerH)
            header.addClass('active').fadeIn();
        else
            header.removeClass('active');
    });


    // set header height
    function handleResize() {
        var headerHeight = header.height();

        return headerHeight;
    }
    handleResize();

    $(window).resize(function() { handleResize(); });

    header.parent().height(handleResize());

    // show menu
    $('.brands li').hide();
    $('.brands li:lt(4)').show();

    // rangeslider
    $("#range_slider").each(function() {
        $(this).ionRangeSlider({
            min: 0,
            max: $(this).attr('data-max') || 100,
            type: "double",
            skin: "round",
            postfix: "€",
            hide_min_max: true
        });
    })

    $('.special-carousel').slick({
        nextArrow: $('.special-carousel-wrap .s-next'),
        prevArrow: $('.special-carousel-wrap .s-prev'),
        variableWidth: true,
        autoplay: false,
        draggable: true,
        slidesToScroll: 1
    });

    // pages carousel
    $('.special-carousel-pages').slick({
        nextArrow: $('.carousel-controls .next'),
        prevArrow: $('.carousel-controls .prev'),
        variableWidth: true,
        autoplay: false,
        draggable: true,
        slidesToScroll: 1
    });

    // category carousel
    $('.category-carousel').slick({
        autoplay: true,
        autoplaySpeed: 6000,
        arrows: false,
        slidesToShow: 1,
        fade: true,
        cssEase: 'linear',
        dots: true,
    });

    $('.product-offer-carousel').slick({
        nextArrow: $('.carousel-controls .next'),
        prevArrow: $('.carousel-controls .prev'),
        variableWidth: true,
        autoplay: false,
        draggable: true,
        slidesToScroll: 1
    });

    $('.slick-gallery').slick({
        slidesToShow: 3,
        slidesToScroll: 1,
        autoplay: false,
        infinite: false,
        nextArrow: $('.carousel-gallery-controls .next'),
        prevArrow: $('.carousel-gallery-controls .prev'),
    });
    // end slick

    // like
    $('.js-rate').on('click', function(e) {
        $(this).addClass('active');

        $.post($(this).attr('data-url'), (response) => {
            $(this).find('.count').text('(' + response + ')');
        });

        e.preventDefault();

    })


    // floatin inputs
    $('.form-group').each(function() {
        changeState($(this));
    });

    $('.form-group').find('input, select, textarea').each(function() {
        $(this).focus(() => {
            $(this).parent().addClass('active');
        }).blur(() => {
            $(this).parent().removeClass('active');
        })
    });

    function changeState(input) {
        var val = input.val();

        if (val && val.length > 0) {
            input.parents('.form-group').addClass('has-value');
        } else {
            input.parents('.form-group').removeClass('has-value');
        }
    }

    $('.form-control').each(function() {
        changeState($(this));
    }).on('focusout change', function() {
        changeState($(this));
    });

    $('#focusRealSearchInput').on('focus click', function() {
        $('#search-bar-input').focus();
    });


    // hamburger
    $(".js-hamburger").click(function() {
        $(this).find('.hamburger').toggleClass("is-active");
    });

    /**
     * Alert
     *
     */
    var d = new Date(),
        today = (d.getDate() + '-' + d.getMonth()),
        storageKey = 'alertDate-';

    $('[data-close-alert]').on('mousedown', function() {
        let type = $(this).attr('data-close-alert');

        localStorage[storageKey + type] = today;
    });

    $('[data-alert-wrapper]').each(function() {
        let type = $(this).attr('data-alert-wrapper');

        if (localStorage[storageKey + type] == today) {
            $(this).remove();
        } else {
            $(this).addClass('--visible');
        }
    })

    /**
     * Filter menu
     *
     */
    $('.js-menu-filter').on('click', function() {
        $('.product-search-filters').toggleClass('active');
    });

    $(document).click(function() {
        $('.product-search-filters').removeClass('active');
    });

    $(".product-search-filters, .js-menu-filter").click(function(event) {
        event.stopPropagation();
    });

    /**
     * Alert discount
     *
     */
    $('.week--discount').delay(5000).addClass('fade-in');
});